function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon ionic-md-close-circle-outline",
  fill: "#3c00dc"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 400",
  d: "M14.625 2.953A11.667 11.667 0 116.37 6.37a11.623 11.623 0 018.255-3.417m0-2.953A14.625 14.625 0 1029.25 14.625 14.623 14.623 0 0014.625 0z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 401",
  d: "M21.938 19.891l-2.046 2.046-5.267-5.266-5.266 5.266-2.046-2.046 5.266-5.266-5.266-5.266 2.046-2.046 5.266 5.266 5.266-5.266 2.046 2.046-5.266 5.266z"
}));

function SvgRemoveinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.25,
    height: 29.25,
    viewBox: "0 0 29.25 29.25"
  }, props), _ref);
}

export default SvgRemoveinline;